import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private internalIsDataGridOpened = false;
  private isColumnPanelOpened = false;

  // with accordance to docs and angular source code
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  leftPanel: Subject<TemplateRef<any> | null> = new Subject();

  toggleDataGridChange: Subject<boolean> = new Subject();
  toggleColumnPanelChange: Subject<boolean> = new Subject();
  exportChange: Subject<void> = new Subject();

  constructor() {
    this.toggleDataGridChange.subscribe((isOpened: boolean): void => {
      this.internalIsDataGridOpened = isOpened;
    });

    this.toggleColumnPanelChange.subscribe((isOpened: boolean): void => {
      this.isColumnPanelOpened = isOpened;
    });
  }

  get isDataGridOpened() {
    return this.internalIsDataGridOpened;
  }

  toggleDataGrid(isOpened: boolean) {
    this.toggleDataGridChange.next(isOpened);
  }

  toggleColumnPanel(isOpened: boolean) {
    this.toggleColumnPanelChange.next(isOpened);
  }

  export() {
    this.exportChange.next();
  }
}
